var map = {
	"./Devesh.jpg": 3324,
	"./Rajeev_Ohri.png": 3941,
	"./Shukla.jpg": 5883,
	"./ajayKumar.jpg": 5098,
	"./bahuguna.jpg": 5566,
	"./bharat.jpg": 1171,
	"./charlesClancy.png": 6807,
	"./clancy.jpg": 2379,
	"./debapriya.jpg": 1924,
	"./gen.jpg": 2769,
	"./kris.jpg": 1752,
	"./krisGaj.png": 7396,
	"./kuppusamy.jpg": 9760,
	"./martin.jpg": 2650,
	"./naik.jpg": 6856,
	"./natarajan.jpg": 8543,
	"./rajeev.jpg": 9178,
	"./robertMartin.jpg": 6110,
	"./sadeep.jpg": 4709,
	"./somitra.jpg": 980,
	"./spearker5.jpg": 7595,
	"./trishank.png": 5113,
	"./vinayak.jpg": 6802
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4631;